module.exports = __webpack_public_path__ + "static/media/airport_virgin.40046973.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/img/airports/airport_virgin.jpg
// module id = 1006
// module chunks = 0